import { render, staticRenderFns } from "./SitemanagerOwnerCommentDialog.vue?vue&type=template&id=6590cf08&"
import script from "./SitemanagerOwnerCommentDialog.vue?vue&type=script&lang=js&"
export * from "./SitemanagerOwnerCommentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports